import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-route-planning"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7C16 10.25 12 13 12 13C12 13 8 10.2496 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12.75 7C12.75 7.41421 12.4142 7.75 12 7.75C11.5858 7.75 11.25 7.41421 11.25 7C11.25 6.58579 11.5858 6.25 12 6.25C12.4142 6.25 12.75 6.58579 12.75 7Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16 7C16 10.25 12 13 12 13C12 13 8 10.2496 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12.75 7C12.75 7.41421 12.4142 7.75 12 7.75C11.5858 7.75 11.25 7.41421 11.25 7C11.25 6.58579 11.5858 6.25 12 6.25C12.4142 6.25 12.75 6.58579 12.75 7Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5 11H3V21H21V11H19M3.5 12.5L3.85952 13.0876M6.49414 15.2344C6.89214 15.4668 7.30436 15.6741 7.72836 15.8548M11.209 16.7051C11.6686 16.74 12.1299 16.746 12.5903 16.723M16.0449 15.9827C16.4743 15.815 16.8926 15.6206 17.2976 15.4004M19.8203 13.5147L20.5 13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapRoutePlanning = Vue.extend<IconProps>({
  name: 'MapRoutePlanningIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-route-planning',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapRoutePlanning;
